export { Sizes } from './sizes.component';
